import Firebase from './base';

export default Firebase;